import { FC, useMemo } from 'react'
import { formatRewardAmount } from 'helpers/formatHelpers'
import { RawSocialInnerInsight } from 'interfaces/socialInsights'
import { BadgeWithAnnotation } from 'components/features/pfm/BadgeWithAnnotation/BadgeWithAnnotation'

type RewardBadgeProps = {
  insight: RawSocialInnerInsight
  AnnotationsContainer: FC
}

export const RewardBadge: FC<RewardBadgeProps> = (props) => {
  const { insight, AnnotationsContainer } = props
  const { reward } = insight

  const annotationText = useMemo(() => {
    if (reward && reward.value && reward.text) {
      return reward.text
    }
    return
  }, [reward])

  const title = useMemo(() => {
    if (!reward) {
      return null
    }

    return `${ formatRewardAmount(reward) } Reward`
  }, [reward])

  if (!reward || !reward.value) {
    return null
  }

  return (
    <BadgeWithAnnotation
      type='reward'
      annotationText={ annotationText }
      AnnotationsContainer={ AnnotationsContainer }
    >
      { title }
    </BadgeWithAnnotation>
  )
}
